export default __webpack_public_path__ + "static/media/walkthru-tick.55b84af3.svg";